// jQuery document load and ready
$(window).on("load", () => {
  $(document).ready(function () {

    let medicines_id = [];
    const ajaxLoader = document.getElementById('ajax-loading');
      // cehck cart items
      document.querySelectorAll('[data-cartitem]').forEach((el) =>{
        medicines_id.push(el.getAttribute("data-cartitem"));
      });

    const search_form = document.querySelectorAll(".search-form-wrapper");

    update_add_to_cart_items();

    search_form.forEach((el) => {
      let load_more_posts_btn = el.querySelector("[type=submit]");
      const input_text = el.querySelector(".search-form__input");
      let loading = false,
        canBeLoaded = true;

      load_more_posts_btn.addEventListener("click", function () {
        let name = input_text.value;
        if (name.length >= 3) {
          ajax_load_more(name);
        } else {
          $("#ajax-items-result").html("");
        }
      });

      input_text.addEventListener("input", function () {
        let name = this.value;

        if (name.length >= 3) {
          ajax_load_more(name);
        } else {
          $("#ajax-items-result").html("");
        }
      });

      function ajax_load_more(name = "") {
        // event.preventDefault();
        let button = el.querySelector("[type=submit]");
        $("#ajax-items-result").html("");
        var data = {
          action: "load_posts",
          count: 5,
          name: name,
        };
        if (canBeLoaded && !loading) {
          loading = true;
          $.ajax({
            url: my_ajax_object.ajaxurl,
            data: data,
            type: "POST",
            beforeSend: function (xhr) {
              canBeLoaded = false; // you see, the AJAX call is in process, we shouldn't run it again until complete
              button.classList.add("loading");
            },
            success: function (response) {
              response = JSON.parse(response);
              if (response.content) {
                $("#ajax-items-result").show();
                $("#ajax-items-result").append(response.content);

                // el.appendChild(response.content); // insert posts here
                // document.querySelectorAll('.post:not(.loaded)').forEach( post => {
                //   increse = increse + 100;
                //   setTimeout(function(){
                //     post.classList.add('loaded');
                //   },increse);
                // });
              }

              canBeLoaded = true; // the ajax is completed, now we can run it again
              setTimeout(() => {
                loading = false;
              }, 500);
            },
            complete: function () {

              button.classList.remove("loading");
              // update items
              update_add_to_cart_items();
            },
          });
        }
      }
    });
    function ajax_add_to_cart() {
      event.preventDefault();
      // let button = el.querySelector('[type=submit]');
      let canBeLoaded = true;
      let loading = false;
      // $("#ajax-items-result").html("");
      var data = {
        action: "add_item_to_cart",
        medicines: medicines_id,
        // count: 5,
      };
      if(medicines_id.length >= 4){
        alert('Maksymalnie 3 leki na receptę');
        return;

      }

      if (canBeLoaded && !loading) {
        loading = true;
        $.ajax({
          url: my_ajax_object.ajaxurl,
          data: data,
          type: "POST",
          beforeSend: function (xhr) {
            ajaxLoader.classList.add('is--loading');
            canBeLoaded = false; // you see, the AJAX call is in process, we shouldn't run it again until complete
            // button.classList.add('loading');
          },
          success: function (response) {
            $("#custom-cart__list").html("");
            response = JSON.parse(response);

            $("#custom-cart__list").append(response.content);
            canBeLoaded = true; // the ajax is completed, now we can run it again
            if($('main.front-page').length != 0 || $('section.search-template').length != 0){
              window.location = response.redirect;
            }


            loading = false;

          },
          complete: function () {
            ajaxLoader.classList.remove('is--loading');

            action_remove_item_from_cart();
            // button.classList.remove('loading');
          },
        });
      }
    }
    function action_remove_item_from_cart(){
      document.querySelectorAll('[data-cartitem] .bin').forEach((el) =>{
        el.addEventListener('click', function(){
          // console.log( 'remove: ' );
          // console.log( el.parentElement );
          ajax_remove_from_cart( el.parentElement );
        });
      });

    }

    function update_add_to_cart_items(){
      let search_form_items = document.querySelectorAll(
        ".ajax-items-result__item"
      );
      search_form_items.forEach((el) => {
        el.addEventListener("click", function () {
          // medicines_id.push();
          medicines_id.push(this.getAttribute("data-post"));
          // console.log( medicines_id );
          ajax_add_to_cart();
        });
      });
    }
    function ajax_remove_from_cart(element) {
      // event.preventDefault();
      // let button = el.querySelector('[type=submit]');
      let canBeLoaded = true;
      let loading = false;
      let id = element.getAttribute('data-cartitem');
      // medicines_id.remove(id);
      medicines_id = medicines_id.filter(item => item !== id);

      var data = {
        action: "remove_from_cart",
        exclude: id,

      };
      if (canBeLoaded && !loading) {
        loading = true;
        $.ajax({
          url: my_ajax_object.ajaxurl,
          data: data,
          type: "POST",
          beforeSend: function (xhr) {
            ajaxLoader.classList.add('is--loading');

            canBeLoaded = false; // you see, the AJAX call is in process, we shouldn't run it again until complete
            // button.classList.add('loading');
          },
          success: function (response) {
            response = JSON.parse(response);
            element.remove();
            canBeLoaded = true; // the ajax is completed, now we can run it again
            setTimeout(() => {
              loading = false;
            }, 500);
          },
          complete: function () {
            // button.classList.remove('loading');
            ajaxLoader.classList.remove('is--loading');

          },
        });
      }
    }
    function hide_ajax_elements(){
      let eventListener = document.addEventListener("click", function (clickEvent) {
        let el = clickEvent.target;
        let inPopup = false;
        if (el.id === "ajax-items-result") {
          inPopup = true;
        }
        while ((el = el.parentNode)) {
          if (el.id == "ajax-items-result") {
            inPopup = true;
          }
        }
        if (!inPopup) $("#ajax-items-result").html("");
      });

    }
    hide_ajax_elements();
    action_remove_item_from_cart();

  });
});
